import { createApp } from 'vue';

// A camada de fundação (Fase 1): tokens, tipografia, reset e animações.
//
// Vem ANTES do App e de qualquer componente de propósito. O CSS de um SFC entra na folha na ordem
// em que o módulo é avaliado, e o que chega depois vence no desempate de especificidade — se esta
// linha descesse, o token seria sobrescrito pelo componente em vez de servir de base para ele.
import './assets/styles/index.css';

import App from './App.vue';
import store from './core/store';
import router from './router';
import i18n from './i18n/i18n';
import VueGtag from 'vue-gtag-next';
import { config, pageView } from './plugins/analytics';
import oraculoLogs from './core/services/oraculo-logs.service';
import errorInterceptor from './core/services/error-interceptor.service';

const app = createApp(App);

// Configurar o VueGtag primeiro
app.use(VueGtag, config);

// Registrar plugins globalmente primeiro
app.config.globalProperties.$i18n = i18n;
app.config.globalProperties.$oraculoLogs = oraculoLogs;
app.config.globalProperties.$errorInterceptor = errorInterceptor;

// 🛡️ Configurar error handler global do Vue
app.config.errorHandler = (error, instance, info) => {
  // Delegar para o ErrorInterceptor
  errorInterceptor.handleVueError(error, instance, info);
};

// Depois montar plugins
app.use(i18n);
app.use(store);
app.use(router);

// 🛡️ Inicializar Error Interceptor (DEPOIS de router e store)
errorInterceptor.initialize({ router, store });

// Watch para atualizar userId no errorInterceptor quando mudar no store
store.watch(
  (state) => state.auth?.userId,
  (newUserId) => {
    errorInterceptor.setUserId(newUserId);
  }
);

// Configurar o router para rastrear mudanças de página
router.afterEach((to) => {
  if (process.env.VUE_APP_NODE_ENV === 'production') {
    setTimeout(() => {
      pageView(to.name || to.path, to.fullPath);
    }, 100);
  }
});

// Service Worker: APENAS em produção (não em development)
if ('serviceWorker' in navigator && process.env.VUE_APP_NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    const swPath = (process.env.BASE_URL || '/') + 'sw.js';
    navigator.serviceWorker
      .register(swPath) 
      .then(reg => console.log('✅ SW registrado com scope:', reg.scope))
      .catch(err => {
        console.error('❌ Erro no registro do SW:', err);
        // Logar erro do SW para o Oráculo (apenas em produção)
        errorInterceptor.logError('Service Worker registration failed', err, {
          category: 'sw-error',
          swPath
        });
      });
  });
}

app.mount('#app');

// Log de inicialização do Fishbay
oraculoLogs.info('Fishbay Frontend Initialized', {
  details: {
    version: '1.0.0',
    environment: process.env.VUE_APP_NODE_ENV || 'development',
    url: process.env.VUE_APP_URL
  }
});
